import Vue          from 'vue'
import Router       from 'vue-router'
import room        from '@/components/room'
import index        from '@/components'
import roomCreation from '@/components/roomCreation'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path      : '/',
      name      : 'Index',
      component : index
    },
    {
      path      : '/room/:id',
      name      : 'room',
      component : room
    },
    {
      path      : '/room_creation',
      name      : 'RoomCreation',
      component : roomCreation
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js